import script from "./Scrubber.vue?vue&type=script&setup=true&lang=js"
export * from "./Scrubber.vue?vue&type=script&setup=true&lang=js"

import "./Scrubber.vue?vue&type=style&index=0&id=45391f1a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45391f1a"]])

export default __exports__